// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__x035E","row":"Layout_row__Rh3tS","col":"Layout_col__K0LSW"};